import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import axiosApiInstance from "app/services/axios";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  submitLoading: false,
  supplyList: [],
  TargtingTypeOptions: {},
  isTargetingTypesLoaded: false,
  locationGroupLoading: false,
  SupplyInventoryLoading: false,
};
export const GetAllSupplyListThunk = createAsyncThunk(
  "supply/GetAllSupplyListThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            payload?.search != "" &&
            payload?.search != undefined &&
            payload?.search != null
              ? "select id,name,target_country,availability,start_date,end_date,creation_date from " +
                tablePrefix +
                "supply where name " +
                DATASOURCE_CONFIG.QUERY_LIKE +
                " '%" +
                payload.search +
                "%' and status!='2' and end_date > " +
                DATASOURCE_CONFIG.CURRENT_DATE +
                " order by creation_date DESC"
              : "select id,name,target_country,availability,start_date,end_date,creation_date from " +
                tablePrefix +
                "supply where status!='2' and end_date > " +
                DATASOURCE_CONFIG.CURRENT_DATE +
                " order by creation_date DESC",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        `${getDataEndPoint}`,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const CreateUpdateSupplyDetailsThunk = createAsyncThunk(
  "company/CreateUpdateSupplyDetailsThunk",
  async (payload) => {
    let Query = "";
    console.log("payload", payload);
    if (payload.id == "" || payload.id == null || payload.id == undefined) {
      Query =
        "insert into " +
        tablePrefix +
        "supply (id,name,start_date,end_date,target_country,target_app_language,target_app,target_cats,target_pubs,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,target_placements,target_supply_deal_id,target_skippable,imp_type,created_by,creation_date,updated_date) values('" +
        payload.supply_create_id +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.startDate +
        "','" +
        payload.endDate +
        "','" +
        payload.country +
        "','" +
        payload.target_app_language +
        "','" +
        payload.target_app +
        "','" +
        payload.target_cats +
        "','" +
        payload.target_pubs +
        "','" +
        payload.target_devicetype +
        "','" +
        payload.target_orientation +
        "','" +
        payload.target_device_os +
        "','" +
        payload.target_connectiontype +
        "','" +
        payload.target_gender +
        "','" +
        payload.target_age +
        "','" +
        payload.target_placements +
        "','" +
        payload.target_supply_deals +
        "','" +
        payload.target_skippable +
        "','" +
        payload.imp_type +
        "','" +
        payload.created_by +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ") ";
    } else {
      var inventoryTabFields = "";
      // if (payload?.update_inventory_tab) {
      inventoryTabFields =
        ",target_pubs='" +
        payload.target_pubs +
        "',target_app_language='" +
        payload.target_app_language +
        "',target_app='" +
        payload.target_app +
        "',target_skippable='" +
        payload.target_skippable +
        "',target_cats='" +
        payload.target_cats +
        "',target_placements='" +
        payload.target_placements +
        "',target_supply_deal_id='" +
        payload.target_supply_deals +
        "'";
      //}

      Query =
        "update " +
        tablePrefix +
        "supply set name='" +
        addslashes(payload.name) +
        "',target_country='" +
        payload.country +
        "',target_devicetype='" +
        payload.target_devicetype +
        "',target_orientation='" +
        payload.target_orientation +
        "',target_device_os='" +
        payload.target_device_os +
        "',target_connectiontype='" +
        payload.target_connectiontype +
        "',target_gender='" +
        payload.target_gender +
        "',target_age='" +
        payload.target_age +
        "',imp_type='" +
        payload.imp_type +
        "' " +
        inventoryTabFields +
        ",updated_date=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "  where id='" +
        payload.id +
        "'";
    }
    // return false;
    const queryBody = {
      queries: [
        {
          query: Query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CreateUpdateSupplyLocationDetailsThunk = createAsyncThunk(
  "supply/CreateUpdateSupplyLocationDetailsThunk",
  async (payload) => {
    let queriesArr = [];
    var supplyId = payload.supply_id;
    var action = payload.action;
    console.log("payload", payload);
    if (payload.is_location) {
      let InsertQuery =
        "insert into " +
        tablePrefix +
        "supply_location_groups (id,supply_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,created_by,creation_date,updated_date) values";
      let InsertValuesArr = [];

      // let InsertLocationLatLongQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "supply_location_groups_latlon (id,location_group_id,supply_id,target_latlon_groups,type,creation_date) values ";

      // let InsertLocationAddressesQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "supply_location_groups_addresses (location_group_id,supply_id,addresses,type,creation_date) values ";
      // let InsertLocationPolygongQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "supply_location_groups_polygons (id,location_group_id,supply_id,target_polygon_groups,type,creation_date) values";
      // let InsertLocationPoiQry =
      //   "Insert into " +
      //   tablePrefix +
      //   "supply_location_groups_poi (location_group_id,supply_id,target_poi,creation_date) values";

      // let InsertLocationLatLongValues = [];
      // let InsertLocationAddressesValues = [];
      // let InsertLocationPolygongValues = [];
      // let InsertLocationPoiValues = [];

      var locationGroupFieldsInfo = payload.formInfo;

      if (action == "edit") {
        queriesArr.push({
          query:
            "update " +
            tablePrefix +
            "supply_location_groups set is_active=0,updated_date=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where  supply_id='" +
            supplyId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        /*** Delete all campaign location groups child tables ***/
        // queriesArr.push({
        //   query:
        //     "delete from "+tablePrefix+"supply_location_groups_latlon where supply_id='" +
        //     supplyId +
        //     "' ",
        //   datasource: DATASOURCE_CONFIG.DATASOURCE,
        // });
        // queriesArr.push({
        //   query:
        //     "delete from "+tablePrefix+"supply_location_groups_polygons where supply_id='" +
        //     supplyId +
        //     "' ",
        //   datasource: DATASOURCE_CONFIG.DATASOURCE,
        // });
        // queriesArr.push({
        //   query:
        //     "delete from " +
        //     tablePrefix +
        //     "supply_location_groups_addresses where supply_id='" +
        //     supplyId +
        //     "' ",
        //   datasource: DATASOURCE_CONFIG.DATASOURCE,
        // });

        // queriesArr.push({
        //   query:
        //     "delete from " +
        //     tablePrefix +
        //     "supply_location_groups_poi where supply_id='" +
        //     supplyId +
        //     "' ",
        //   datasource: DATASOURCE_CONFIG.DATASOURCE,
        // });
      }
      console.log("locationGroupFieldsInfo", locationGroupFieldsInfo);
      for (var n = 0; n < locationGroupFieldsInfo.length; n++) {
        var locationInfo = locationGroupFieldsInfo[n];
        var locId = "";
        if (
          locationInfo.id == "" ||
          locationInfo.id == null ||
          locationInfo.id == undefined
        ) {
          // Create case
          //var insertId = uuid();
          locId = locationInfo.insert_id;
          InsertValuesArr.push(
            "('" +
              locId +
              "','" +
              supplyId +
              "','" +
              addslashes(locationInfo.name) +
              "','" +
              locationInfo.target_city +
              "','" +
              locationInfo.target_state +
              "','" +
              locationInfo.target_dma +
              "','" +
              locationInfo.target_counties +
              "','" +
              locationInfo.target_zipcode +
              "','" +
              locationInfo.target_brands +
              "','" +
              locationInfo.target_congressional_districts +
              "','" +
              locationInfo.target_senate_districts +
              "','" +
              locationInfo.target_house_districts +
              "','" +
              locationInfo.latlon_radius +
              "','" +
              locationInfo.addresses_radius +
              "','" +
              locationInfo.poi_radius +
              "','" +
              addslashes(locationInfo.target_latlon) +
              "','" +
              addslashes(locationInfo.target_polygon) +
              "','" +
              addslashes(locationInfo.target_poi) +
              "','" +
              addslashes(locationInfo.target_addresses) +
              "','" +
              locationInfo.target_latlon_group +
              "','" +
              locationInfo.target_polygon_group +
              "','" +
              locationInfo.target_address_group +
              "','" +
              payload.created_by +
              "'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              "," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ")"
          );
        } else {
          // Update case
          locId = locationInfo.id;
          queriesArr.push({
            query:
              " update " +
              tablePrefix +
              "supply_location_groups set is_active=1,target_city='" +
              locationInfo.target_city +
              "',target_state='" +
              locationInfo.target_state +
              "',target_dma='" +
              locationInfo.target_dma +
              "',target_counties='" +
              locationInfo.target_counties +
              "',target_postalcode='" +
              locationInfo.target_zipcode +
              "',target_brands='" +
              locationInfo.target_brands +
              "',target_congressional_districts='" +
              locationInfo.target_congressional_districts +
              "',target_senate_districts='" +
              locationInfo.target_senate_districts +
              "',target_house_districts='" +
              locationInfo.target_house_districts +
              "',latlon_radius='" +
              locationInfo.latlon_radius +
              "',addresses_radius='" +
              locationInfo.addresses_radius +
              "',poi_radius='" +
              locationInfo.poi_radius +
              "',name='" +
              addslashes(locationInfo.name) +
              "',geo_points='" +
              addslashes(locationInfo.target_latlon) +
              "',geo_polygons='" +
              addslashes(locationInfo.target_polygon) +
              "',target_poi='" +
              addslashes(locationInfo.target_poi) +
              "',target_addresses ='" +
              addslashes(locationInfo.target_addresses) +
              "',target_latlon_groups='" +
              locationInfo.target_latlon_group +
              "',target_polygon_groups='" +
              locationInfo.target_polygon_group +
              "',target_address_groups='" +
              locationInfo.target_address_group +
              "',updated_date=" +
              DATASOURCE_CONFIG.CURRENT_DATE +
              " where id='" +
              locationInfo.id +
              "' and supply_id='" +
              supplyId +
              "' ",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          });
        }
        /***Insert Child Tables Data***/
        // if (locationInfo?.target_poi && locationInfo.target_poi.length > 0) {
        //   for (var p = 0; p < locationInfo.target_poi.length; p++) {
        //     var poi = locationInfo.target_poi[p];
        //     InsertLocationPoiValues.push(
        //       "('" +
        //         locId +
        //         "','" +
        //         supplyId +
        //         "','" +
        //         JSON.stringify(poi) +
        //         "'," +
        //         DATASOURCE_CONFIG.CURRENT_DATE +
        //         ")"
        //     );
        //   }
        // }
        // For Polygons
        // if (
        //   locationInfo?.target_polygon &&
        //   locationInfo.target_polygon.length > 0
        // ) {
        //   for (var a = 0; a < locationInfo.target_polygon.length; a++) {
        //     var polygonInfo = locationInfo.target_polygon[a];
        //     if (polygonInfo.action == "add" && polygonInfo.active == 1) {
        //       // Insert Polygon
        //       delete polygonInfo.coords.is_new;
        //       InsertLocationPolygongValues.push(
        //         "('" +
        //           polygonInfo.id +
        //           "','" +
        //           locId +
        //           "','" +
        //           supplyId +
        //           "','" +
        //           JSON.stringify(polygonInfo.coords) +
        //           "','" +
        //           polygonInfo.type +
        //           "'," +
        //           DATASOURCE_CONFIG.CURRENT_DATE +
        //           ")"
        //       );
        //     } else if (polygonInfo.action == "edit") {
        //       // Update polygons
        //       queriesArr.push({
        //         query:
        //           " update " +
        //           tablePrefix +
        //           "supply_location_groups_polygons set is_active='" +
        //           polygonInfo.active +
        //           "',target_polygon_groups='" +
        //           JSON.stringify(polygonInfo.coords) +
        //           "',type='" +
        //           polygonInfo.type +
        //           "' where id='" +
        //           polygonInfo.id +
        //           "' and location_group_id='" +
        //           locId +
        //           "' ",
        //         datasource: DATASOURCE_CONFIG.DATASOURCE,
        //       });
        //     } else if (polygonInfo.action == "delete") {
        //       // Update polygons
        //       queriesArr.push({
        //         query:
        //           " update " +
        //           tablePrefix +
        //           "supply_location_groups_polygons set is_active='0' where id='" +
        //           polygonInfo.id +
        //           "' and location_group_id='" +
        //           locId +
        //           "' ",
        //         datasource: DATASOURCE_CONFIG.DATASOURCE,
        //       });
        //     }
        //   }
        // }
        // For LatLong
        // if (
        //   locationInfo?.target_latlon &&
        //   locationInfo.target_latlon.length > 0
        // ) {
        //   for (var d = 0; d < locationInfo.target_latlon.length; d++) {
        //     var latLonInfo = locationInfo.target_latlon[d];
        //     let geopoints;
        //     if (latLonInfo.type == "file") {
        //       geopoints = latLonInfo.geopoints;
        //     } else {
        //       geopoints = { coords: latLonInfo.geopoints };
        //     }
        //     if (latLonInfo.action == "add" && latLonInfo.active == 1) {
        //       delete latLonInfo.geopoints.is_new;

        //       InsertLocationLatLongValues.push(
        //         "('" +
        //           latLonInfo.id +
        //           "','" +
        //           locId +
        //           "','" +
        //           supplyId +
        //           "','" +
        //           JSON.stringify(geopoints) +
        //           "','" +
        //           latLonInfo.type +
        //           "'," +
        //           DATASOURCE_CONFIG.CURRENT_DATE +
        //           ")"
        //       );
        //     } else if (latLonInfo.action == "edit") {
        //       // Update Geopoints
        //       queriesArr.push({
        //         query:
        //           " update " +
        //           tablePrefix +
        //           "supply_location_groups_latlon set is_active='" +
        //           latLonInfo.active +
        //           "',target_latlon_groups='" +
        //           JSON.stringify(geopoints) +
        //           "',type='" +
        //           latLonInfo.type +
        //           "' where id='" +
        //           latLonInfo.id +
        //           "' and location_group_id='" +
        //           locId +
        //           "' ",
        //         datasource: DATASOURCE_CONFIG.DATASOURCE,
        //       });
        //     } else if (latLonInfo.action == "delete") {
        //       // Update polygons
        //       queriesArr.push({
        //         query:
        //           " update " +
        //           tablePrefix +
        //           "supply_location_groups_latlon set is_active='0' where id='" +
        //           latLonInfo.id +
        //           "' and location_group_id='" +
        //           locId +
        //           "' ",
        //         datasource: DATASOURCE_CONFIG.DATASOURCE,
        //       });
        //     }
        //   }
        // }
        // For Addresses
        // if (
        //   locationInfo?.target_addresses &&
        //   locationInfo.target_addresses.length > 0
        // ) {
        //   for (var s = 0; s < locationInfo.target_addresses.length; s++) {
        //     var address = locationInfo.target_addresses[s];
        //     InsertLocationAddressesValues.push(
        //       "('" +
        //         locId +
        //         "','" +
        //         supplyId +
        //         "','" +
        //         address +
        //         "','manual'," +
        //         DATASOURCE_CONFIG.CURRENT_DATE +
        //         ")"
        //     );
        //   }
        // }
        // if (
        //   locationInfo?.target_addresses_files &&
        //   locationInfo.target_addresses_files.length > 0
        // ) {
        //   for (var t = 0; t < locationInfo.target_addresses_files.length; t++) {
        //     var address = locationInfo.target_addresses_files[t];
        //     InsertLocationAddressesValues.push(
        //       "('" +
        //         locId +
        //         "','" +
        //         supplyId +
        //         "','" +
        //         JSON.stringify(address) +
        //         "','file'," +
        //         DATASOURCE_CONFIG.CURRENT_DATE +
        //         ")"
        //     );
        //   }
        // }
      }

      if (InsertValuesArr.length > 0) {
        InsertQuery += InsertValuesArr.join(",");
        queriesArr.push({
          query: InsertQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      // if (InsertLocationLatLongValues.length > 0) {
      //   InsertLocationLatLongQry += InsertLocationLatLongValues.join(",");
      //   queriesArr.push({
      //     query: InsertLocationLatLongQry,
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
      // if (InsertLocationAddressesValues.length > 0) {
      //   InsertLocationAddressesQry += InsertLocationAddressesValues.join(",");
      //   queriesArr.push({
      //     query: InsertLocationAddressesQry,
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
      // if (InsertLocationPolygongValues.length > 0) {
      //   InsertLocationPolygongQry += InsertLocationPolygongValues.join(",");
      //   queriesArr.push({
      //     query: InsertLocationPolygongQry,
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
      // if (InsertLocationPoiValues.length > 0) {
      //   InsertLocationPoiQry += InsertLocationPoiValues.join(",");
      //   queriesArr.push({
      //     query: InsertLocationPoiQry,
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
    }

    // if (payload.is_inventory) {
    //   //
    //   var queryRes = prepareSupplyInventoryQueries(
    //     payload.inventoryFormData,
    //     supplyId,
    //     payload.action
    //   );

    //   if (queryRes.length > 0) {
    //     queriesArr = queriesArr.concat(queryRes);
    //   }
    // }
    const queryBody = {
      queries: queriesArr,
    };
    console.log("Location queryBody", queryBody);

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const prepareSupplyInventoryQueries = (InventoryData, supplyId, type) => {
  let queriesArr = [];
  if (type == "edit") {
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "supply_placements where  supply_id='" +
        supplyId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "supply_analysis_supply_deals where  supply_id='" +
        supplyId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  let InsertQuery =
    "insert into " +
    tablePrefix +
    "supply_placements (supply_id,target_placements,is_included,creation_date) values ";
  let InsertPlacementsValues = [];
  let isIncluded = InventoryData.placementsInfo?.is_included ? 1 : 0;
  for (var i = 0; i < InventoryData.placementsInfo.data.length; i++) {
    InsertPlacementsValues.push(
      "('" +
        supplyId +
        "','" +
        InventoryData.placementsInfo.data[i] +
        "','" +
        isIncluded +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ")"
    );
  }
  if (InsertPlacementsValues.length > 0) {
    InsertQuery += InsertPlacementsValues.join(",");
    queriesArr.push({
      query: InsertQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  let supplyDealQuery =
    "insert into " +
    tablePrefix +
    "supply_analysis_supply_deals (supply_id,supply_deal_id,is_included,creation_date) values ";
  let InsertSupplyDealValues = [];
  let supplyDealIsIncluded = InventoryData.supplyDealIdsInfo?.is_included
    ? 1
    : 0;

  for (var j = 0; j < InventoryData.supplyDealIdsInfo.data.length; j++) {
    InsertSupplyDealValues.push(
      "('" +
        supplyId +
        "','" +
        InventoryData.supplyDealIdsInfo.data[j] +
        "','" +
        supplyDealIsIncluded +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ")"
    );
  }
  if (InsertSupplyDealValues.length > 0) {
    supplyDealQuery += InsertSupplyDealValues.join(",");
    queriesArr.push({
      query: supplyDealQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  return queriesArr;
};

export const GetSupplyDetailsThunk = createAsyncThunk(
  "supply/GetSupplyDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "supply where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetSupplyLocationGroupThunk = createAsyncThunk(
  "supply/GetSupplyLocationGroupThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          /****get campaign location groups data** */
          query:
            "select * from " +
            tablePrefix +
            "supply_location_groups where supply_id='" +
            payload.id +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetSupplyInventoryDataThunk = createAsyncThunk(
  "supply/GetSupplyInventoryDataThunk",
  async (payload) => {
    var queriesArr = [
      {
        /****Get target placemenst data** */
        query:
          "select pp.id, pp.name,pp.pub_code,sp.is_included from " +
          tablePrefix +
          "publisher_placements as pp," +
          tablePrefix +
          "supply_placements sp WHERE pp.id=" +
          DATASOURCE_CONFIG.REGEX +
          "(sp.target_placements, '!','') and sp.supply_id ='" +
          payload.id +
          "' ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
      {
        query:
          "select rds.dealid as id, rds.name,sasd.is_included from " +
          tablePrefix +
          "rtb_deals_supply as rds," +
          tablePrefix +
          "supply_analysis_supply_deals sasd WHERE rds.dealid=" +
          DATASOURCE_CONFIG.REGEX +
          "(sasd.supply_deal_id, '!','') and sasd.supply_id ='" +
          payload.id +
          "' ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];

    if (payload?.pub_code && payload.pub_code.length) {
      queriesArr.push({
        query:
          "select id,pub_code, name from " +
          tablePrefix +
          "publishers where pub_code in ('" +
          payload.pub_code.join("','") +
          "') and active='1';",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });
    }
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetSupplyTargetingsByIds = createAsyncThunk(
  "supply/GetSupplyTargetingsByIds",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var targetInfo = payload[i];
      if (targetInfo.key == "target_city") {
        queriesArr.push({
          query:
            "select concat(concat(concat(concat(country_code, '_'), state_code), '_'), Name),id, latitude as lat, longitude as lng, concat(concat(concat((Name), ' '), state_code), ' (CITY)') as Name,'city' as type from " +
            tablePrefix +
            "cities where id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_state") {
        queriesArr.push({
          query:
            "select concat(concat(country_code, '_'), iso2) as state_code,id,  concat(name,' (STATE)') as Name, latitude as lat, longitude as lng,'state' as type from " +
            tablePrefix +
            "states where id in ('" +
            targetInfo["values"].join("','") +
            "') ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_dma") {
        queriesArr.push({
          query:
            "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
            tablePrefix +
            "geodma where dma_code in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_counties") {
        queriesArr.push({
          query:
            "select id as county_code, concat(concat(county_name, ' '), state) as name from " +
            tablePrefix +
            "counties where id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "brands") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_poi") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name as brand,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_congressional_districts") {
        queriesArr.push({
          query:
            "SELECT dm.id AS id,concat(concat(state_code, '-'), cd116_fip) AS name,0 as lat,0 as lng FROM " +
            tablePrefix +
            "congressional_districts dm where  id in ('" +
            targetInfo["values"].join("','") +
            "') GROUP BY dm.id,dm.state_code, cd116_fip  ORDER BY name",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_senate_districts") {
        queriesArr.push({
          query:
            "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,0 as lat,0 as lng FROM " +
            tablePrefix +
            "state_legislative_districts dm WHERE dm.geo_id in ('" +
            targetInfo["values"].join("','") +
            "') GROUP BY dm.geo_id,dm.state_code,district ORDER BY name;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_pubs") {
        queriesArr.push({
          query:
            "select id,pub_code, name from " +
            tablePrefix +
            "publishers where pub_code in ('" +
            targetInfo["values"].join("','") +
            "') and active='1';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      // else if (targetInfo.key == "target_placements") {
      //   queriesArr.push({
      //     query:
      //       "select id, name,pub_code from "+tablePrefix+"publisher_placements WHERE id in ('" +
      //       targetInfo["values"].join("','") +
      //       "') ",
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetSupplyLocationChildTablesDataThunk = createAsyncThunk(
  "supply/GetSupplyLocationChildTablesDataThunk",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var childInfo = payload[i];
      if (childInfo.key == "target_addresses") {
        queriesArr.push({
          query:
            "select addresses as target_addresses,type from " +
            tablePrefix +
            "supply_location_groups_addresses where location_group_id='" +
            childInfo.id +
            "';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_latlon") {
        queriesArr.push({
          query:
            "select id,target_latlon_groups as target_latlon,type from " +
            tablePrefix +
            "supply_location_groups_latlon where location_group_id='" +
            childInfo.id +
            "' and is_active='1' ;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_polygon") {
        queriesArr.push({
          query:
            "select id,target_polygon_groups as target_polygon,type from " +
            tablePrefix +
            "supply_location_groups_polygons where location_group_id='" +
            childInfo.id +
            "' and is_active='1';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_poi") {
        queriesArr.push({
          query:
            "select target_poi from " +
            tablePrefix +
            "supply_location_groups_poi  where location_group_id='" +
            childInfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }
    const queryBody = {
      queries: queriesArr,
    };
    console.log("Child Table Query", queryBody);
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateSupplyStatusThunk = createAsyncThunk(
  "supply/UpdateSupplyStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "supply set status='2',updated_date=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Supply = createSlice({
  name: "supply",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(GetAllSupplyListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllSupplyListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];

          state.supplyList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })

      .addCase(GetAllSupplyListThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })

      .addCase(GetSupplyDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetSupplyDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetSupplyDetailsThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })
      .addCase(CreateUpdateSupplyDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(CreateUpdateSupplyDetailsThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.results.length > 0 &&
          action.payload.data.results.includes("Updated")
        ) {
          //state.accountsDetails = action.payload.data.results[0];
        }
        state.submitLoading = false;
      })
      .addCase(CreateUpdateSupplyDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.submitLoading = false;
      })
      .addCase(CreateUpdateSupplyLocationDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(
        CreateUpdateSupplyLocationDetailsThunk.fulfilled,
        (state, action) => {
          if (
            action.payload.data?.results.length > 0 &&
            action.payload.data.results.includes("Updated")
          ) {
            //state.accountsDetails = action.payload.data.results[0];
          }
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdateSupplyLocationDetailsThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.submitLoading = false;
        }
      )
      .addCase(GetSupplyLocationGroupThunk.pending, (state) => {
        state.locationGroupLoading = true;
      })
      .addCase(GetSupplyLocationGroupThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.locationGroupLoading = false;
      })
      .addCase(GetSupplyLocationGroupThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.locationGroupLoading = false;
      })
      .addCase(GetSupplyInventoryDataThunk.pending, (state) => {
        state.SupplyInventoryLoading = true;
      })
      .addCase(GetSupplyInventoryDataThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.SupplyInventoryLoading = false;
      })
      .addCase(GetSupplyInventoryDataThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.SupplyInventoryLoading = false;
      })
      .addCase(GetSupplyTargetingsByIds.pending, (state) => {
        //state.loading = true;
        state.locationGroupLoading = true;
      })
      .addCase(GetSupplyTargetingsByIds.fulfilled, (state, action) => {
        //state.loading = false;
        state.locationGroupLoading = false;
      })
      .addCase(GetSupplyTargetingsByIds.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.locationGroupLoading = false;
      })
      .addCase(GetSupplyLocationChildTablesDataThunk.pending, (state) => {
        //state.loading = true;
      })
      .addCase(
        GetSupplyLocationChildTablesDataThunk.fulfilled,
        (state, action) => {
          //state.loading = false;
        }
      )
      .addCase(
        GetSupplyLocationChildTablesDataThunk.rejected,
        (state, action) => {
          //toast.error("Something went Wrong!");
        }
      )
      .addCase(UpdateSupplyStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateSupplyStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let supList = state.supplyList;
          let supplyId = action.meta.arg.id;
          supList = supList.filter((item) => item.id !== supplyId);
          state.supplyList = supList;
        }
        state.loading = false;
      })
      .addCase(UpdateSupplyStatusThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

const { actions, reducer } = Supply;

export default reducer;
